<template>
  <div class="d-flex justify-center">
    <div
      :class="{ isSubtitle: isSubtitle }"
      class="title-row d-flex flex-column align-center"
    >
      <span v-if="html" v-html="title"></span>
      <span v-else class="header-title">{{ title }}</span>
      <span v-if="html" v-html="description"></span>
      <span v-else class="header-description">{{ description }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TitleRow',
    props: {
      html: {
        required: false,
        default: false,
        type: Boolean,
      },
      title: {
        required: true,
        default: '',
        type: String,
      },
      description: {
        required: true,
        default: '',
        type: String,
      },
      isSubtitle: {
        required: false,
        default: false,
        Type: Boolean,
      },
    },
  };
</script>
<style lang="scss" scoped>
  .title-row {
    gap: 24px;
    max-width: 928px;
    margin: 5px 0 32px 0;
    text-align: center;
    z-index: 99;
    &.isSubtitle {
      margin-top: 0 !important;
    }

    .header-title {
      font-size: 28px !important;
      font-weight: 500 !important;
      line-height: 30px;
      letter-spacing: -1px !important;
      text-align: center !important;
    }

    .header-description {
      font-size: 22px !important;
      font-weight: 400 !important;
      line-height: 26px !important;
      text-align: center !important;
    }
  }
  @media screen and (max-width: 800px) {
    .title-row {
      margin-top: 40px;
    }
  }
</style>
